module.exports = __webpack_public_path__ + "assets/images/CNY5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CNY5.png
// module id = 1346
// module chunks = 1